import { ControlledInput } from "components/Card/ControlledInput";
import { TextInput } from "components/inputs";
import type { Control } from "react-hook-form";

import type { OrganizationSettingsFormValues } from "./SettingsPage";

type OrganizationAddressSectionProps = {
  control: Control<OrganizationSettingsFormValues>;
  handleFieldChange: (
    field: keyof OrganizationSettingsFormValues,
    value: string,
  ) => Promise<void>;
};

const OrganizationAddressSection = ({
  control,
  handleFieldChange,
}: OrganizationAddressSectionProps) => {
  return (
    <>
      <div className="header-primary flex jc-sb ai-c">
        <div className="text-sm text-gray-500">Organization Address</div>
      </div>

      <ControlledInput
        control={control}
        name="legal_name"
        label="Legal Name"
        errors={{}}
        onSave={(value) => handleFieldChange("legal_name", String(value))}
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="street"
        label="Street Address"
        errors={{}}
        onSave={(value) => handleFieldChange("street", String(value))}
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="street2"
        label="Street Address 2"
        errors={{}}
        onSave={(value) => handleFieldChange("street2", String(value))}
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="city"
        label="City"
        errors={{}}
        onSave={(value) => handleFieldChange("city", String(value))}
        componentType={TextInput}
        maxLength={100}
      />

      <ControlledInput
        control={control}
        name="state"
        label="State"
        errors={{}}
        onSave={(value) => handleFieldChange("state", String(value))}
        componentType={TextInput}
        maxLength={255}
      />

      <ControlledInput
        control={control}
        name="zip_code"
        label="ZIP Code"
        errors={{}}
        onSave={(value) => handleFieldChange("zip_code", String(value))}
        componentType={TextInput}
        maxLength={20}
      />
    </>
  );
};

export default OrganizationAddressSection;
